export default "__VITE_ASSET__2c56fd4e__"